const buildCountries = countries => {
  return { isoCode: countries.iso, name: countries.name }
}

export default buildCountries
